import { render, staticRenderFns } from "./issueDetail.vue?vue&type=template&id=f45d966e"
import script from "./issueDetail.vue?vue&type=script&lang=js"
export * from "./issueDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports